import React from 'react';
import { Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { Code, Briefcase, Mail, Link2 } from 'lucide-react';
import { useMediaQuery } from '../../../hooks/useMediaQuery';
import CodeIntegration from './CodeIntegration';
import CRMIntegration from './CRMIntegration';
import EmailIntegration from './EmailIntegration';
import WebhooksIntegration from './WebhooksIntegration';

const menuItems = [
  { icon: Code, label: "Integration code", path: 'code' },
  { icon: Briefcase, label: 'CRM', path: 'crm' },
  { icon: Mail, label: 'Emailing', path: 'email' },
  { icon: Link2, label: 'Webhooks', path: 'webhooks' }
];

export default function IntegrationsLayout() {
  const isMobile = useMediaQuery('(max-width: 1024px)');

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white mb-2">Integrations</h1>
        <p className="text-gray-400">Connect your chatbot to your existing tools</p>
      </div>

      <div className="flex gap-8">
        {/* Sidebar - caché sur mobile */}
        {!isMobile && (
          <div className="w-64">
            <div className="space-y-1">
              {menuItems.map(({ icon: Icon, label, path }) => (
                <NavLink
                  key={path}
                  to={path}
                  className={({ isActive }) => `
                    flex items-center gap-3 px-3 py-2 rounded-lg transition-all
                    ${isActive 
                      ? 'bg-indigo-500/20 text-indigo-400' 
                      : 'text-gray-400 hover:bg-white/5 hover:text-white'
                    }
                  `}
                >
                  <Icon className="w-5 h-5" />
                  <span>{label}</span>
                </NavLink>
              ))}
            </div>
          </div>
        )}

        {/* Content */}
        <div className="flex-1">
          <Routes>
            <Route path="code" element={<CodeIntegration />} />
            <Route path="crm" element={<CRMIntegration />} />
            <Route path="email" element={<EmailIntegration />} />
            <Route path="webhooks" element={<WebhooksIntegration />} />
            <Route path="*" element={<Navigate to="code" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}